// validationSchema.ts
import * as yup from "yup";

export const usuarioSchema = yup.object().shape({
  nome: yup.string().required("O nome é obrigatório"),
  email: yup
    .string()
    .email("E-mail inválido")
    .required("O e-mail é obrigatório"),
  senha: yup
    .string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("A senha é obrigatória"),
  confirmarSenha: yup
    .string()
    .oneOf([yup.ref("senha")], "A confirmação da senha não confere")
    .required("A confirmação de senha é obrigatória"),
  codigo: yup.string().optional(),
});

export const confirmaSchema = yup.object().shape({
  id: yup.number().required("ID do usuário é obrigatório"),
  codigo: yup
    .string()
    .required("O código para verificação e confirmação da conta é obrigatório"),
});

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("E-mail inválido")
    .required("O e-mail é obrigatório"),
  senha: yup
    .string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("A senha é obrigatória"),
});

export const recuperarSenhaSchema = yup.object().shape({
  id: yup.number().required("ID do usuário é obrigatório"),
  codigo: yup
    .string()
    .required("O código para verificação e confirmação da conta é obrigatório"),
  senha: yup
    .string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("A senha é obrigatória"),
  confirmarSenha: yup
    .string()
    .oneOf([yup.ref("senha")], "A confirmação da senha não confere")
    .required("A confirmação de senha é obrigatória"),
});
